module.exports = __webpack_public_path__ + "static/RoslindaleText-Regular-d9569635f0d3b26e63378ade4a3454c1.eot";